import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { DueTimeSpanPipe } from './due-time-span.pipe'
import { LogTimeSpanPipe } from './log-time-span.pipe'
import { HighlightTextPipe } from './highlight-text.pipe';
import { HtmlToTextPipe } from './html-to-text.pipe'

@NgModule({
  declarations: [DueTimeSpanPipe, LogTimeSpanPipe, HighlightTextPipe, HtmlToTextPipe],
  imports: [CommonModule],
  exports: [DueTimeSpanPipe, LogTimeSpanPipe, HighlightTextPipe, HtmlToTextPipe],
})
export class PipesModule { }
